<template>
  <div class="sidebar-inner">
    <!-- Top Section -->
    <div class="top-section">
      <h4 class="mb-1">Changelog</h4>
      <hr>
      <!-- Is Loading -->
      <div class="text-center mt-4" v-if="isLoadingAudits">
        <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
      </div>
      <!-- / Is Loading -->

      <!-- Loaded -->
      <div v-if="!isLoadingAudits && audits !== null">
        <div class="audit-data mt-3" v-if="audits.length === 0">
          <div class="property-card">
            <b class="property-name text-danger">
              No audits to show
            </b>
          </div>
        </div>
      </div>
      <!-- / Loaded -->

      <!-- Has Audits -->
      <div v-if="!isLoadingAudits && audits.length">
       <audit v-for="audit in auditsNewestFirst" :audit="audit" :key="audit.id"></audit>
      </div>
      <!-- / Has Audits -->
    </div>
    <!-- / Top Section -->
    <!-- Bottom Section -->
    <div class="bottom-section pt-3 pb-3">
      <a href="#" @click.prevent="loadAudits" class="btn btn-itg-dark btn-block">
        <i class="fa fa-sync mr-1"></i>
        Refresh
      </a>
    </div>
    <!-- / Bottom Section -->
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Audit from "./AuditSidebar/Audit";
const _ = require('lodash');

export default {
  name: "AuditSidebar",
  computed: {
    ...mapGetters('ticketViewer', {
      isLoadingAudits: 'isLoadingAudits',
      audits: 'audits'
    }),

    auditsNewestFirst() {
      return _.reverse(this.audits);
    }
  },
  created() {
    this.loadAudits();
  },
  methods: {
    ...mapActions('ticketViewer', {
      loadAudits: 'loadAudits'
    })
  },
  components: {Audit}
}
</script>

<style scoped>

</style>